export default __webpack_public_path__ + "static/media/product_NPC_PC_Hk.7c5c7bea.webp";